import {
  Skeleton,
  type SkeletonProps,
  Stack,
  type StackProps,
} from '@mantine/core'
import { range } from 'lodash'

type LoadingSkeletonProps = {
  maxRange: number
  stackProps?: StackProps
  'data-testid'?: string
} & SkeletonProps

const LoadingSkeleton = ({
  maxRange,
  stackProps,
  'data-testid': testId,
  ...props
}: LoadingSkeletonProps) => {
  return (
    <Stack {...stackProps} data-testid={testId}>
      {range(0, maxRange).map((row) => (
        <Skeleton key={row} {...props} />
      ))}
    </Stack>
  )
}

export default LoadingSkeleton
